import { Theme } from '@mui/material/styles'

export const serviceLocationPropertyCardStyles = {
  container: {
    display: 'flex',
    fontSize: '14px',
    fontWeight: 500,
  },

  name: {
    whiteSpace: 'nowrap',
    width: '400px',
    overflowX: 'hidden',
    textOverflow: 'ellipsis',
    paddingBottom: (theme: Theme) => theme.spacing(),
  },

  value: {
    width: 'auto',
    textAlign: 'left',
    paddingBottom: (theme: Theme) => theme.spacing(),
    paddingLeft: (theme: Theme) => theme.spacing(),
  },
}
